<template>
  <div>
    <vs-table id="order_item_table" :data="product_order_items" stripe>

      <template slot="thead">
        <vs-th width="20%">CODE</vs-th>
        <vs-th width="15%">QUANTITY (KG)</vs-th>
        <vs-th width="15%">UNIT PRICE Excl VAT (KG/{{__accountCurrency()}})</vs-th>
        <vs-th width="15%" class="justify-end ml-auto mr-0"> TOTAL PRICE Excl VAT ({{__accountCurrency()}})</vs-th>
        <vs-th width="15%" class="text-xs">ITEM STATUS</vs-th>
        <vs-th v-if="status_id <= 2" width="20%">ACTION</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td :data="data[indextr].formulation_code">
            {{ data[indextr].formulation_code }}
          </vs-td>

          <vs-td :data="data[indextr].quantity">
            {{ data[indextr].quantity }}
          </vs-td>

          <vs-td :data="data[indextr].price">
            {{ (Number(data[indextr].price)).toFixed(2) }}
          </vs-td>
          <vs-td  class="flex justify-end mr-20"  :data="data[indextr].price">
            {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
          </vs-td>

          <vs-td :data="data[indextr].item_status">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <a class="flex items-center text-dark ml-1" href="#">
                <vs-chip v-if="data[indextr].item_status !== 'In-QC'" style="border-radius: 0" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
                  {{ data[indextr].item_status === 'Pending' ? 'Accepted' : data[indextr].item_status }}
                </vs-chip>
                <i
                  v-if="['Pending', 'Customer-Received', 'Returned'].includes(data[indextr].item_status)"
                  class="material-icons"
                >
                  expand_more
                </i>
              </a>
              <vs-dropdown-menu>
                <vs-dropdown-item class="w-64"
                                  @click.prevent="onClickChangeItemStatus(data[indextr].id, status.name)"
                                  v-for="status in product_order_item_statuses"
                                  v-bind:key="status.name"
                                  v-if="status.is_visible && status.before_status.includes(data[indextr].item_status)">
                  {{status.name}}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
<!--            <vs-chip v-else style="border-radius: 0" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">-->
<!--              {{ data[indextr].item_status || 'Submitted'}}-->
<!--            </vs-chip>-->
          </vs-td>

          <vs-td v-if="status_id <= 2">
            <div class="vx-row">
              <!-- <vx-tooltip v-if="['Pending', 'Submitted'].includes(data[indextr].item_status)"  class="flex justify-start mr-2" text="Update product Qty" position="bottom">
                <vs-button class="flex justify-end" @click="onClickUpdateProductOrder(data[indextr])"
                           size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
              </vx-tooltip> -->
             <vx-tooltip  class="mr-2" text="Documents" position="bottom">
               <vs-button class=""  @click="onClickOpenOrderDocuments(data[indextr].formulation_type, data[indextr].work_orders, data[indextr].courier_shipments, data[indextr].document)"
                          size="small" color="primary" type="border" icon-pack="feather" icon="icon-file"></vs-button>
             </vx-tooltip>
             <vx-tooltip  class="flex justify-start mr-2" text="Change Request" position="bottom">
                <vs-button class="flex justify-end" @click="onClickSubmitChangeRequest(data[indextr])"
                           size="small" color="danger" type="border" icon-pack="feather" icon="icon-settings"></vs-button>
              </vx-tooltip>
            </div>
          </vs-td>

        </vs-tr>
        <vs-tr>
          <vs-td style="font-weight: bolder">Total</vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td class="flex mr-20 justify-end" style="font-weight: bolder">{{totalCalculator()}}</vs-td>
          <vs-td></vs-td>
          <vs-td v-if="status_id <= 2"></vs-td>
        </vs-tr>
      </template>

    </vs-table>

<!--    <vs-prompt-->
<!--      @cancel="productObj={}"-->
<!--      @accept="onClickUpdateQty"-->
<!--      @close="activePrompt = false"-->
<!--      :title="productObj.formulation_code + ' - Update product content'"-->
<!--      accept-text="Update"-->
<!--      color="primary"-->
<!--      :active.sync="activePrompt">-->

<!--      <div class="vx-row mb-3">-->
<!--        <div class="vx-col md:w-full w-full md:mb-0">-->
<!--          <small class="label">Unit price ({{account_currency}})</small>-->
<!--          <vs-input v-model="productObj.price" disabled class="w-full" />-->
<!--        </div>-->
<!--      </div>-->


<!--      <div class="vx-row mb-3">-->
<!--        <div class="vx-col md:w-full w-full md:mb-0">-->
<!--          <small class="label">Quantity</small>-->
<!--          <vs-input v-model="productObj.quantity" class="w-full" />-->
<!--        </div>-->
<!--      </div>-->

<!--    </vs-prompt>-->


    <update-product-order-items-pop-up v-on:refreshItems="refreshItems" v-bind:creditDetails="creditDetails" ref="updateProductOrderItemsPopUp" />
    <product-order-documents-pop-up ref="productOrderDocumentsPopUp"/>
    <customer-order-item-change-request-pop-up ref="customerOrderItemChangeRequestPopUp"/>
  </div>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  import UpdateProductOrderItemsPopUp from '@/components/popups/customer/product-orders/UpdateProductOrderItemsPopUp'
  import {product_order_item_statuses} from '@/constants/statuses'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import ProductOrderTable from './ProductOrderTable'
  import ProductOrderDocumentsPopUp from '@/components/popups/customer/product-orders/documents/ProductOrderDocumentsPopUp'
  import CustomerOrderItemChangeRequestPopUp from '@/components/popups/customer/product-orders/CustomerOrderItemChangeRequestPopUp.vue'

  export default {
    name: "ProductOrderTable",
    props: {
      items: {
        type: Array,
        default: []
      },
      id: {
        default: ''
      },
      status_id: {
        default: ''
      },
      is_item_status_handled_individually: {
        default: false,
        type: Boolean
      }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    data() {
      return {
        activePrompt: false,
        productObj: {},
        creditDetails: {},
        product_order_item_statuses: product_order_item_statuses,
        product_order_items: this.items
      }
    },
    async mounted() {
      await this.getCreditDetails()
    },
    methods: {
      async refreshItems() {
        this.$emit('refresh')
      },
      totalCalculator() {
        let total = 0;
        this.product_order_items.forEach((m) => {
          if (!!m.price) {
            total = total + Number(m.price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      async onClickRemoveProductFromOrder(id) {
        const payload = this.product_order_items.filter((n) => {
          return n.id !== id
        }).map((n) => {
          return {id: n.id, price: n.price, quantity: n.quantity, type: n.type}
        })
        await this.updateContent({formulation_items: payload})
      },
      async updateContent(payload) {
        await this.$vs.loading({
          container: '#order_item_table',
          scale: 0.45
        })
        try {
          const {data} = await CustomerRepository.updateProductOrderContent(this.id, payload)
          this.$emit('refresh')
        }catch (e) {
        }
        this.$vs.loading.close('#order_item_table > .con-vs-loading')
      },
      async onClickUpdateQty() {
        const payload = this.product_order_items.filter((n) => {
          if (n.id === this.productObj.id) {
            n.quantity = this.productObj.quantity
          }
          return n
        }).map((n) => {
          return {id: n.id, price: n.price, quantity: n.quantity, type: n.type}
        })
        await this.updateContent({formulation_items: payload})
      },
      async onClickUpdateProductOrder(data) {
        await this.$refs.updateProductOrderItemsPopUp.openPopup(this.id)
        // this.productObj = data
        // this.activePrompt = true
      },
      async getCreditDetails() {
        try {
          const {data} = await CustomerRepository.getCustomerAccountCredit()
          this.creditDetails = data.data.formulation_items
        } catch (e) {
        }
      },
      itemStatusColorFactory(status_name) {
        const status = this.product_order_item_statuses.find((n) => n.name === status_name)
        return status ? status.color : 'dark'
      },
      async getProductOrderDetails() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getCustomerProductOrder(this.id)
        this.product_order_items = data.data.formulation_items
        this.$vs.loading.close()
      },
      async onClickChangeItemStatus(id, status) {
        await this.$vs.loading({
          container: '#order_item_table',
          scale: 0.45
        })
        try {
          const payload = {status: status}
          await CustomerRepository.productOrdersItemStatusChange(id, payload)
          await this.getProductOrderDetails()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#order_item_table > .con-vs-loading')
      },
      customerStatusChangeFactory(status) {
        if(!status) {
          return 'Submitted'
        }
        switch(status) {
          case 'In-Manufacturing':
            return 'Pending'
          case 'In-QC':
            return 'Pending'
          case 'In-Dispatch':
            return 'Manufactured'
          case 'Dispatch Booked':
            return 'Manufactured'
          default:
            return status
        }
      },
      onClickOpenOrderDocuments(formulation_type, wo_arr, courier_shipments, documents) {
        this.$refs.productOrderDocumentsPopUp.openPopup(formulation_type, wo_arr, courier_shipments, documents)
      },
      onClickSubmitChangeRequest(data) {
        this.$refs.customerOrderItemChangeRequestPopUp.openPopup(data)
      }
    },
    watch: {
      items: function (new_value, old_value) {
        this.product_order_items = new_value
      }
    },
    components: {
      UpdateProductOrderItemsPopUp,
      ProductOrderDocumentsPopUp,
      CustomerOrderItemChangeRequestPopUp
    }
  }
</script>

<style scoped>

</style>
